(() => {
  'use strict';

  const CATEGORIES = [
    {
      name: 'Vitaminas y minerales',
      items: [
        ['Vitamina C', '/products/vitamina-c-premium-90-capsulas-500-mg-ya-ax-vida-100-puro'],
        ['Complejo B', '/products/complejo-vitamina-b-90-capsulas-500-mg-yaax-vida-100-puro'],
        ['Citrato de Magnesio', '/products/citrato-de-magnesio-90-capsulas-500-mg-yaax-vida-100-puro'],
        ['Citrato de Potasio', '/products/citrato-de-potasio-90-capsulas-500-mg-yaax-vida-100-puro'],
        ['Omega 3', '/products/omega-3-premium-90-capsulas-500-mg-ya-ax-vida-100-puro']
      ]
    },
    {
      name: 'Aminoácidos',
      items: [
        ['L-Arginina 500 g', '/products/l-arginina-100-pura-500-grs-polvo'],
        ['L-Arginina 1 kg', '/products/copia-de-l-arginina-100-pura-500-grs-polvo'],
        ['L-Citrulina cápsulas', '/products/l-citrulina-90-capsulas-500-mg-ya-ax-vida-100-puro'],
        ['L-Citrulina 500 g', '/products/l-citrulina-polvo-500-grs-pura-100'],
        ['L-Tirosina', '/products/l-tirosina-90-capsulas-500-mg-ya-ax-vida-100-puro']
      ]
    },
    {
      name: 'Botánicos',
      items: [
        ['Ashwagandha', '/products/ashwagandha-90-capsulas-500-mg-yaax-vida-100-pura'],
        ['Moringa', '/products/moringa-90-capsulas-500-mg-ya-ax-vida-100-puro'],
        ['Maca Negra', '/products/maca-negra-90-capsulas-500-mg-ya-ax-vida-100-puro'],
        ['Ajo Negro', '/products/ajo-negro-90-capsulas-500-mg-ya-ax-vida-100-puro'],
        ['Ginkgo Biloba', '/products/ginkgo-biloba-500g-puro-en-polvo-100'],
        ['Té Matcha', '/products/te-matcha-organico-500-grs-polvo-100-puro'],
        ['Cúrcuma', '/products/curcuma-organica-en-polvo-100-natural-500g']
      ]
    },
    {
      name: 'Colágenos',
      items: [
        ['Colágeno cápsulas', '/products/colageno-hidrolizado-puro-90-capsulas-500-mg-yaax-vida'],
        ['Colágeno 500 g', '/products/colageno-hidrolizado-100-puro-500g'],
        ['Colágeno 1 kg', '/products/copia-de-colageno-hidrolizado-100-puro-500g'],
        ['Colágeno Marino 500 g', '/products/colageno-marino-hidrolizado-polvo-500-grs-100-puro'],
        ['Colágeno Marino 1 kg', '/products/copia-de-colageno-marino-hidrolizado-polvo-500-grs-100-puro'],
        ['Ácido Hialurónico + Biotina + Colágeno', '/products/acido-hialuronico-biotina-y-colageno-90-capsulas-500-mg-yaax-vida']
      ]
    },
    {
      name: 'Nutrición deportiva',
      items: [
        ['Creatina 500 g', '/products/copia-de-creatina-monohidratada-1-kg-polvo-100-pura'],
        ['Creatina 1 kg', '/products/creatina-monohidratada-1-kg-polvo-100-pura'],
        ['L-Citrulina 500 g', '/products/l-citrulina-polvo-500-grs-pura-100'],
        ['L-Arginina 500 g', '/products/l-arginina-100-pura-500-grs-polvo'],
        ['Betabel 500 g', '/products/betabel-organico-en-polvo-500g-100-natural-yaax-vida']
      ]
    }
  ];

  const TOP_CAMPAIGN_PRODUCTS = {
    'citrato-de-magnesio-90-capsulas-500-mg-yaax-vida-100-puro': {
      badge: 'MÁS VENDIDO YAAX VIDA',
      short: 'Citrato de Magnesio',
      presentation: '90 cápsulas · 500 mg'
    },
    'citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro': {
      badge: 'TOP VENTAS YAAX VIDA',
      short: 'Citrato de Magnesio',
      presentation: '500 g · polvo'
    },
    'copia-de-citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro': {
      badge: 'TOP VENTAS YAAX VIDA',
      short: 'Citrato de Magnesio',
      presentation: '1 kg · polvo'
    }
  };

  const MAGNESIUM_CAMPAIGN_FORMATS = [
    ['citrato-de-magnesio-90-capsulas-500-mg-yaax-vida-100-puro', '90 cápsulas'],
    ['citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro', '500 g polvo'],
    ['copia-de-citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro', '1 kg polvo']
  ];

  const PRESENTATION_GROUPS = [
    [
      ['curcuma-organica-en-polvo-100-natural-500g', '500 g'],
      ['curcuma-organica-en-polvo-100-natural-1-kilo', '1 kg']
    ],
    [
      ['betabel-organico-en-polvo-500g-100-natural-yaax-vida', '500 g'],
      ['betabel-organico-en-polvo-1-kg-100-natural', '1 kg']
    ],
    [
      ['copia-de-creatina-monohidratada-1-kg-polvo-100-pura', '500 g'],
      ['creatina-monohidratada-1-kg-polvo-100-pura', '1 kg']
    ],
    [
      ['colageno-marino-hidrolizado-polvo-500-grs-100-puro', '500 g'],
      ['copia-de-colageno-marino-hidrolizado-polvo-500-grs-100-puro', '1 kg']
    ],
    [
      ['te-matcha-organico-500-grs-polvo-100-puro', '500 g'],
      ['copia-de-te-matcha-organico-500-grs-polvo-100-puro', '1 kg']
    ],
    [
      ['l-citrulina-90-capsulas-500-mg-ya-ax-vida-100-puro', '90 cápsulas'],
      ['l-citrulina-polvo-500-grs-pura-100', '500 g polvo'],
      ['copia-de-l-citrulina-polvo-500-grs-pura-100', '1 kg polvo']
    ],
    [
      ['colageno-hidrolizado-puro-90-capsulas-500-mg-yaax-vida', '90 cápsulas'],
      ['colageno-hidrolizado-100-puro-500g', '500 g polvo'],
      ['copia-de-colageno-hidrolizado-100-puro-500g', '1 kg polvo']
    ],
    [
      ['ginkgo-biloba-500g-puro-en-polvo-100', '500 g'],
      ['copia-de-ginkgo-biloba-500g-puro-en-polvo-100', '1 kg']
    ],
    [
      ['l-arginina-100-pura-500-grs-polvo', '500 g'],
      ['copia-de-l-arginina-100-pura-500-grs-polvo', '1 kg']
    ],
    [
      ['citrato-de-potasio-90-capsulas-500-mg-yaax-vida-100-puro', '90 cápsulas'],
      ['citrato-de-potasio-polvo-100-puro-500-grs', '500 g polvo'],
      ['citrato-de-potasio-polvo-100-puro-1kg', '1 kg polvo']
    ],
    [
      ['citrato-de-magnesio-90-capsulas-500-mg-yaax-vida-100-puro', '90 cápsulas'],
      ['citrato-de-magnesio-100-gr-polvo-yaax-vida-100-puro', '100 g polvo'],
      ['copia-de-citrato-de-magnesio-1-kilo-polvo-yaax-vida-100-puro', '250 g polvo'],
      ['citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro', '500 g polvo'],
      ['copia-de-citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro', '1 kg polvo']
    ]
  ];

  function categoryMarkup(cssClass) {
    const groups = CATEGORIES.map(group => {
      const links = group.items.map(([label, href]) => `<a href="${href}">${label}</a>`).join('');
      return `<div class="yaax-category-group"><strong>${group.name}</strong>${links}</div>`;
    }).join('');
    const actions = `<div class="yaax-category-actions"><a href="/collections/all?finder=1">Encuentra tu suplemento</a><a href="/collections/all?sort_by=best-selling">Más vendidos</a></div>`;
    return `<div class="${cssClass}">${actions}${groups}</div>`;
  }

  function promoteBestSellingMerchandising() {
    document.querySelectorAll('a[href="/collections/all"], a[href$="/collections/all"]').forEach((a) => {
      if (!a.search) a.href = '/collections/all?sort_by=best-selling';
    });

    if (window.location.pathname === '/collections/all') {
      const grid = document.querySelector('#ProductGridContainer, .product-grid-container');
      if (grid && !document.querySelector('.yaax-collection-discovery')) {
        const bar = document.createElement('div');
        bar.className = 'page-width yaax-collection-discovery';
        bar.innerHTML = '<a class="is-primary" href="/collections/all?sort_by=best-selling">Más vendidos</a><a href="/collections/all?finder=1">Encuentra tu suplemento</a><a href="/collections/capsulas">Cápsulas</a><a href="/collections/polvos">Polvos</a>';
        grid.parentNode.insertBefore(bar, grid);
      }
    }
  }

  function addDesktopSearchTrigger() {
    if (document.querySelector('.yaax-desktop-search-trigger')) return;
    const icons = document.querySelector('.header__icons');
    const modal = icons && icons.querySelector('details-modal.header__search');
    if (!icons || !modal) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'yaax-desktop-search-trigger';
    button.setAttribute('aria-label', 'Buscar suplementos');

    const sourceIcon = modal.querySelector('summary .icon-search');
    if (sourceIcon) {
      const icon = sourceIcon.cloneNode(true);
      icon.setAttribute('aria-hidden', 'true');
      button.appendChild(icon);
    }
    const label = document.createElement('span');
    label.textContent = 'Buscar suplementos...';
    button.appendChild(label);

    const openSearch = () => {
      const summary = modal.querySelector('summary');
      if (!summary) return;
      summary.click();
      window.setTimeout(() => {
        const input = modal.querySelector('input[type="search"]');
        if (input) input.focus();
      }, 80);
    };

    button.addEventListener('click', openSearch);
    icons.insertBefore(button, modal);
    document.body.classList.add('yaax-search-trigger-ready');
  }

  function addDesktopCategories() {
    if (document.querySelector('.yaax-categories-menu')) return;
    const menu = document.querySelector('.header__inline-menu > ul');
    if (!menu) return;
    const li = document.createElement('li');
    li.className = 'yaax-categories-menu';
    li.innerHTML = `<details><summary class="header__menu-item list-menu__item link focus-inset">Categorías</summary>${categoryMarkup('yaax-categories-panel')}</details>`;
    const allProductsLink = Array.from(menu.children).find(el => /todos los productos/i.test(el.textContent || ''));
    if (allProductsLink && allProductsLink.nextSibling) {
      menu.insertBefore(li, allProductsLink.nextSibling);
    } else {
      menu.appendChild(li);
    }
    document.addEventListener('click', (event) => {
      const details = li.querySelector('details');
      if (details && details.open && !li.contains(event.target)) details.removeAttribute('open');
    });
  }

  function addMobileCategories() {
    if (document.querySelector('.yaax-mobile-categories')) return;
    const menu = document.querySelector('.menu-drawer__navigation .menu-drawer__menu');
    if (!menu) return;
    const li = document.createElement('li');
    li.className = 'yaax-mobile-categories';
    li.innerHTML = `<details><summary class="menu-drawer__menu-item list-menu__item link link--text focus-inset">Categorías</summary>${categoryMarkup('yaax-mobile-categories-panel')}</details>`;
    menu.appendChild(li);
  }

  function mixMatchHtml(compact = false) {
    return `<div class="yaax-mixmatch${compact ? ' yaax-mixmatch--compact' : ''}">
      <strong>ARMA TU PEDIDO Y AHORRA</strong>
      <span>2 productos participantes = <b>10% adicional</b> · 3+ = <b>15% adicional</b> · Puedes combinarlos.</span>
      <small>El descuento se aplica automáticamente sobre el precio de oferta en productos participantes.</small>
    </div>`;
  }

  function addMixMatchPromos() {
    if (document.body.classList.contains('template-product')) {
      const qb = document.querySelector('quantity-breaks');
      if (qb && !document.querySelector('.product__info-container .yaax-mixmatch')) qb.insertAdjacentHTML('afterend', mixMatchHtml(true));
    }

    if (document.body.classList.contains('template-index')) {
      const main = document.querySelector('#MainContent');
      const firstSection = main && main.querySelector(':scope > .shopify-section');
      if (firstSection && !main.querySelector('.yaax-home-mixmatch-wrap')) {
        const wrap = document.createElement('div');
        wrap.className = 'page-width yaax-home-mixmatch-wrap';
        wrap.innerHTML = mixMatchHtml(false);
        firstSection.insertAdjacentElement('afterend', wrap);
      }
    }

    if (document.body.classList.contains('template-collection')) {
      const grid = document.querySelector('#ProductGridContainer, .product-grid-container');
      if (grid && !document.querySelector('.yaax-collection-mixmatch-wrap')) {
        const wrap = document.createElement('div');
        wrap.className = 'page-width yaax-collection-mixmatch-wrap';
        wrap.innerHTML = mixMatchHtml(false);
        grid.parentNode.insertBefore(wrap, grid);
      }
    }
  }

  function currentHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function addPresentationSelector() {
    if (!document.body.classList.contains('template-product') || document.querySelector('.yaax-presentations')) return;
    const handle = currentHandle();
    if (TOP_CAMPAIGN_PRODUCTS[handle]) return;
    const group = PRESENTATION_GROUPS.find(group => group.some(([h]) => h === handle));
    if (!group || group.length < 2) return;
    const qb = document.querySelector('quantity-breaks');
    const form = document.querySelector('product-form.main-product-form');
    const anchor = qb || form;
    if (!anchor) return;
    const links = group.map(([h, label]) => `<a href="/products/${h}" class="yaax-presentation-pill${h === handle ? ' is-current' : ''}"${h === handle ? ' aria-current="page"' : ''}>${label}</a>`).join('');
    const panel = document.createElement('div');
    panel.className = 'yaax-presentations';
    panel.innerHTML = `<strong>Elige la presentación que prefieras</strong><span>Compara formatos del mismo producto y elige el que mejor se adapte a tu compra.</span><div class="yaax-presentation-pills">${links}</div>`;
    anchor.insertAdjacentElement('beforebegin', panel);
  }


  function addCartMixMatch() {
    const container = document.querySelector('.cart-drawer-items-and-upsell');
    if (!container) return;

    // Subscription carts use a simpler checkout path: do not show Mix & Match
    // messaging that could imply an additional discount on recurring items.
    if (container.dataset.yaaxHasSubscription === 'true') {
      document.querySelectorAll('#CartDrawer .yaax-cart-mixmatch').forEach((el) => el.remove());
      return;
    }

    // Keep a single Mix & Match message in the drawer for one-time carts.
    document.querySelectorAll('#CartDrawer .yaax-cart-mixmatch').forEach((el) => {
      if (!container.contains(el)) el.remove();
    });
    const existing = container.querySelectorAll('.yaax-cart-mixmatch');
    existing.forEach((el, index) => { if (index > 0) el.remove(); });
    if (container.querySelector('.yaax-cart-mixmatch')) return;

    const el = document.createElement('div');
    el.className = 'yaax-cart-mixmatch';
    el.innerHTML = '<strong>Combina y ahorra</strong><span>2 productos participantes = 10% adicional · 3 o más = 15% adicional.</span>';
    container.insertAdjacentElement('afterbegin', el);
  }

  function runHeroABTest() {
    if (!document.body.classList.contains('template-index')) return;
    const key = 'yaax_hero_cta_v1';
    let variant = localStorage.getItem(key);
    if (variant !== 'A' && variant !== 'B') {
      variant = Math.random() < 0.5 ? 'A' : 'B';
      localStorage.setItem(key, variant);
    }
    const hero = document.querySelector('[id*="__e6750b05-7703-4f69-ab7c-9ffb0acf18fb"]');
    const button = hero && hero.querySelector('.banner__buttons .button');
    if (button) {
      button.dataset.yaaxAbVariant = variant;
      if (variant === 'B') button.textContent = 'Ver favoritos Yaax Vida';
      button.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'yaax_hero_cta_click', variant });
        if (typeof window.clarity === 'function') window.clarity('event', `yaax_hero_cta_${variant}`);
      }, { once: true });
    }
    const tagClarity = () => {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'yaax_hero_cta_test', variant);
        return true;
      }
      return false;
    };
    if (!tagClarity()) {
      let attempts = 0;
      const timer = setInterval(() => {
        attempts += 1;
        if (tagClarity() || attempts >= 10) clearInterval(timer);
      }, 1000);
    }
  }


  function paidCampaignTraffic() {
    const params = new URLSearchParams(window.location.search);
    if (['1', 'true', 'yes'].includes((params.get('campaign') || '').toLowerCase())) return true;
    if (['1', 'true', 'yes'].includes((params.get('landing') || '').toLowerCase())) return true;
    const source = (params.get('utm_source') || '').toLowerCase();
    const medium = (params.get('utm_medium') || '').toLowerCase();
    return /facebook|instagram|meta|fb|ig/.test(source) || /paid_social|paid-social|social_paid|cpc|paid/.test(medium);
  }

  function addMagnesiumCampaignFormat(handle) {
    if (!TOP_CAMPAIGN_PRODUCTS[handle] || document.querySelector('.yaax-magnesium-campaign-format')) return;
    const qb = document.querySelector('quantity-breaks');
    const form = document.querySelector('product-form.main-product-form');
    const anchor = qb || form;
    if (!anchor) return;
    const links = MAGNESIUM_CAMPAIGN_FORMATS.map(([h, label]) =>
      `<a href="/products/${h}" class="yaax-campaign-format-pill${h === handle ? ' is-current' : ''}"${h === handle ? ' aria-current="page"' : ''}>${label}</a>`
    ).join('');
    const panel = document.createElement('div');
    panel.className = 'yaax-magnesium-campaign-format';
    panel.innerHTML = `<strong>Elige la presentación que prefieras</strong><span>Cápsulas para practicidad o polvo en presentaciones de mayor contenido.</span><div class="yaax-campaign-format-pills">${links}</div>`;
    anchor.insertAdjacentElement('beforebegin', panel);
  }

  function addTopSellerBadge(handle) {
    if (!TOP_CAMPAIGN_PRODUCTS[handle] || document.querySelector('.product__info-container .yaax-top-seller-badge')) return;
    const title = document.querySelector('.product__info-container .product__title, .product__info-container h1');
    if (!title) return;
    const badge = document.createElement('div');
    badge.className = 'yaax-top-seller-badge';
    badge.textContent = TOP_CAMPAIGN_PRODUCTS[handle].badge;
    title.insertAdjacentElement('beforebegin', badge);
  }

  function addCampaignStrip(handle) {
    if (!TOP_CAMPAIGN_PRODUCTS[handle] || document.querySelector('.yaax-campaign-strip')) return;
    const main = document.querySelector('#MainContent');
    const productSection = main && main.querySelector(':scope > .shopify-section');
    if (!productSection) return;
    const strip = document.createElement('div');
    strip.className = 'page-width yaax-campaign-strip';
    strip.innerHTML = `<strong>Compra directa en Yaax Vida</strong><span>${TOP_CAMPAIGN_PRODUCTS[handle].badge} · 2 productos participantes: 10% adicional · 3 o más: 15% adicional · Envío gratis desde $1,500.</span>`;
    productSection.insertAdjacentElement('beforebegin', strip);
  }

  // Card TOP VENTAS / MÁS VENDIDO badges are rendered in card-product.liquid.

  function setupTopSellerCampaign() {
    if (!document.body.classList.contains('template-product')) return;
    const handle = currentHandle();
    if (!TOP_CAMPAIGN_PRODUCTS[handle]) return;
    document.body.classList.add('yaax-top-seller-product');
    if (handle === 'citrato-de-magnesio-90-capsulas-500-mg-yaax-vida-100-puro') document.body.classList.add('yaax-top-seller-primary');
    addTopSellerBadge(handle);
    addMagnesiumCampaignFormat(handle);
    if (paidCampaignTraffic()) {
      document.body.classList.add('yaax-campaign-focus');
      addCampaignStrip(handle);
    }
  }

  function boot() {
    // V32: Shopify navigation is native; no duplicate Categorías injection.
    promoteBestSellingMerchandising();
    addMixMatchPromos();
    addPresentationSelector();
    addCartMixMatch();
    setupTopSellerCampaign();
    runHeroABTest();
  }

  function observeCartDrawer() {
    const drawer = document.querySelector('#CartDrawer, cart-drawer');
    if (!drawer) return;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        addCartMixMatch();
      });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function bootOptimized() {
    boot();
    observeCartDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootOptimized, { once: true });
  else bootOptimized();
})();
